export enum Roles {
  FBS_USER = "fbs-user",
  FLEET_AT_HOME_USER = "fleet-at-home-user",
  FLEET_AT_HOME_MANAGER = "fleet-at-home-manager",
  EQUIVOLT_PRE_SALES_MANAGER = "equivolt-pre-sales-manager",
  GAS_STOREMAN = "gas-storeman",
  GAS_REQUESTER = "gas-requester",
  GAS_OCI_USER = "gas-oci-user",
  GLOBAL_GAS_STOREMAN = "global-gas-storeman",
  WCC_MANAGER = "wcc-manager",
  WSC_MANAGER = "wsc-manager",
  THG_QUOTE_MANAGER = "thg-quote-manager",
  VIRTA_USER = "virta-user",
  GAAS_USER = "gaas-user",
  WESTFALEN_ID_ACCOUNT_MANAGER = "westfalen-id-account-manager",
}
